import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { TAG_TREND_KEYWORD_SECTION_TYPE_TO_RECOMMEND_TAG_TYPE } from '../../../../constants/service/app/tagConstants';
import { setTrim } from '../../../../lib/common';
import EditTabTrendKeywordModal from '../../../../views/tag/common/modal/EditTabTrendKeywordModal';
import withModal from '../../../../lib/hoc/withModal';
import { tagActions } from '../../../../store/modules/tag';

class EditTagTrendKeywordModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  추천 태그 리스트 메모
       */
      memo: null,
    };
  }

  /**
   *  태그 트렌드 키워드 편집하기
   */
  onSubmit = () => {
    const { form, data, editTagTrendKeyword } = this.props;
    const { memo } = this.state;
    const { tagTrendKeywordSectionType, targetTagTrendKeywordContentsIdList } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      editTagTrendKeyword({
        recommendTagType: TAG_TREND_KEYWORD_SECTION_TYPE_TO_RECOMMEND_TAG_TYPE[tagTrendKeywordSectionType],
        idList: targetTagTrendKeywordContentsIdList,
        memo: setTrim(memo),
      });

      /**
       *  모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'editTrendKeywordModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <EditTabTrendKeywordModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.tag.editTrendKeywordModal.isOpen,
    data: state.tag.editTrendKeywordModal.data,
  };
};

const mapDispatchToProps = {
  editTagTrendKeyword: tagActions.editTagTrendKeyword,
  toggleModal: tagActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(EditTagTrendKeywordModalContainer)));
